import { useGetManualsPublicationsQuery } from '../../apis/publicationsApi';
import useManualSotExpApiConfig from './useManualSotExpApiConfig';
const useFetchManualPublications = () => {
    const { headers, baseUrl } = useManualSotExpApiConfig();
    const url = `${baseUrl}/publications`;
    const { data, isFetching, isLoading, error, isError, isUninitialized } = useGetManualsPublicationsQuery({
        url,
        headers,
    });
    return { data, isFetching, isLoading, error, isError, isUninitialized };
};
export default useFetchManualPublications;
